import decode from 'jwt-decode';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import getTokens from '../../../utils/getTokens';
import SocketConnect from '../../../utils/socket';

const tokens = getTokens();

const state = {
  isLoggedIn: !!tokens,
  customerId: tokens ? decode(JSON.parse(tokens).access).customer_id : null,
  access: tokens ? JSON.parse(tokens).access : null,
  refresh: tokens ? JSON.parse(tokens).refresh : null,
  userFirstAuth: {},
};
if (state.isLoggedIn) {
  const socket = new SocketConnect();
  socket.connect(true);
}

const store = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default store;
